import { render, staticRenderFns } from "./LicenseRow.vue?vue&type=template&id=208c37c0&"
import script from "./LicenseRow.vue?vue&type=script&lang=js&"
export * from "./LicenseRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports